import { all, fork } from "redux-saga/effects";
import { watchMessageReplyListSaga } from "./messageReply";

export default function* rootMessageReplySagas() {
    yield all([
       fork(watchMessageReplyListSaga),
    ])
}